<template lang="es">
<CModal @mtdclosemodal="mtdclosemodal" :show.sync="boo_modal" :close-on-backdrop="false" :centered="false" :size="'xl'" :btn_cancel="true" :btn_ok="true" :booTitile="true" :title="title">

    <div class="px-2">
        <div class="col-md-12 table-responsive table-container" id="div-tabla-anular">
            <table id="tb-anular" class="table table-bordered">
                <thead class="bg-main text-white" style="font-size: 11px">
                    <tr class="text-align-center">
                        <th scope="col" class="align-middle">N°</th>
                        <th scope="col" class="align-middle">MOLECULA</th>
                        <th scope="col" class="align-middle">COMERCIAL</th>
                        <th scope="col" class="align-middle">MARCA</th>
                        <th scope="col" class="align-middle">UNIDAD</th>
                        <th class="align-middle">CANTIDAD</th>
                        <th scope="col" colspan="1" class="align-middle">S/SUBTOTAL CON IGV</th>
                    </tr>
                </thead>

                <tbody style="font-size: 11px" class="border-main">
                    <tr class="tbody-table1" v-for="(item, index) in dataordendetalle" :key="index">
                        <td>
                            {{ index + 1 }}
                        </td>
                        <td>
                            {{ item.productodetail.molecule }}
                        </td>
                        <td>
                            {{ item.productodetail.commercial }}
                        </td>
                        <td>
                            {{ item.productodetail.brand ? item.productodetail.brand.name : '-'  }}
                        </td>
                        <td>
                            {{ item.productunit.unit.name }}
                        </td>
                        <td>
                            {{ item.quantity_purchase }}
                        </td>
                        <td>
                            {{ item.price_purchase }}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</CModal>
</template>

<script>
import CModal from "@/components/shared/modals/CModal.vue";

import {
    mapActions
} from "vuex";

export default {
    name: "c-logistica-storeDispatch",
    components: {
        CModal,
    },
    props: {
        title: String,
        boo_modal: Boolean,
        dataordendetalle: {
            type: Array,
            default: () => [],
        },
        dataBillDetailEdit: {
            type: Array,
            default: () => [],
        },
    },

    data() {
        return {
        };
    },
    methods: {
        ...mapActions(["get", "post"]),
       
        mtdclosemodal() {
            this.$emit("mtdCloseModalFactura");
        },

     
    },
};
</script>

<style scoped>
.input-p::placeholder {
    font-size: 10px;
}

.input-p {
    font-size: 11px;
}

.btn-register {
    background-color: rgb(144, 0, 82);
    height: 40px;
}

.btn-register:disabled {
    background-color: rgb(208, 138, 177) !important;
    cursor: not-allowed;
}

@media (max-width: 992px) {
    .responsive-proveedor {
        flex-direction: column;
    }

    .responsive-contador {
        flex-direction: column;
    }

    .responsive-contador>div {
        margin-top: 10px;
        width: 100% !important;
    }

    .responsive-footer {
        flex-direction: column;
    }

    .responsive-footer-div {
        justify-content: end;
    }
}

@media (max-width: 365px) {
    .responsive-footer>.text-white {
        flex-direction: column;
        padding: 0px 20px 0px 20px;
    }

    .responsive-footer>.text-white>div {
        margin: 0px 0px 9px 0px !important;
    }
}

#input-cantidad {
    padding: 7px;
    width: 170px;
}

.error-message {
    color: red;
    font-size: 9px;
}

.input-lote {
    width: 55px;
}

.input-barcode {
    width: 110px;
}

#input-lote {
    padding: 7px;
    width: 100px;
}

#input-fecha {
    padding: 7px;
    width: 190px;
}

#input-registro {
    padding: 7px;
    width: 180px;
}

.anterior-siguiente:focus {
    background: #900052;
}

.anterior-siguiente:hover {
    background: #bb026c;
}

.dropdown-toggle {
    width: 175px !important;
    height: 30px;
}

.observation {
    width: 550px;
}

.circular-btn {
    border-radius: 50%;
    background-color: #900052;
    color: white;
    width: 30px;
    height: 30px;
    font-size: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
}
</style>
